import { slugify } from '../../helpers/strings';
import { reducer, initialStateBase } from './newCollection';
import { popularImgReducer } from './popularCategory';
import mergeWith from 'lodash/mergeWith';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { queryStringToParams } from 'Helpers/url';

const merge = (...args) => mergeWith(...args, (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
        return objValue.concat(srcValue);
    }
    return undefined;
});

export const CATEGORIES = 'CATEGORIES';
export const CATEGORY_REQUIRED_HEADERS = { 'x-panamera-client-id': `web-${PLATFORM}` };

export const urls = {
    getCategories: '/api/categories',
    getCategory: id => `/api/categories/${id}`
};

export const initialState = {
    ...initialStateBase,
    metadataKey: 'categories'
};

const extractSubcategories = (data, subCategories, category, parentId = 0) => {
    const findParamDefinition = (section, key) => {
        const definitions = data.metadata.params_definitions && data.metadata.params_definitions[section];

        if (definitions && definitions.find) {
            return definitions.find(definition => definition.key === key) || {};
        }
        return {};
    };

    const findChildrenParam = param => {
        if (Array.isArray(param.children)) {
            return param.children.map(childParam => {
                const children = findChildrenParam(childParam);

                return Object.assign(
                    { parent: param.key },
                    { children },
                    findParamDefinition('base', childParam.key),
                    findParamDefinition('posting', childParam.key)
                );
            });
        }
        return null;
    };

    if (!category.slug) {
        const slug = slugify(category.name);

        category.slug = `${ slug }/`;
    }
    category.parent_id = parentId;
    if (category.sub_categories) {
        category.sub_categories.forEach(subcategory => {
            subCategories[subcategory.id] = extractSubcategories(data, subCategories, subcategory, category.id);
        });
        category.sub_categories = category.sub_categories.map(subcategory => subcategory.id);
    }

    if (category.params) {
        category.params = category.params.map(param => {
            const metadataBase = findParamDefinition('base', param.key);

            param.definitions = {
                search: merge({}, metadataBase, findParamDefinition('search', param.key)),
                posting: merge({}, metadataBase, findParamDefinition('posting', param.key))
            };

            if (param.definitions.posting.type === 'nested_select') {
                param.children = findChildrenParam(param);
            }

            return param;
        }).sort((a, b) => {
            return a.definitions.posting.display_order - b.definitions.posting.display_order;
        });
    }

    return category;
};

const transformGetData = (state, type, data) => {
    if (type == CATEGORIES) {
        const subCategories = {};
        const newData = data.data.map(category => extractSubcategories(data, subCategories, category));

        return {
            data: newData,
            metadata: {
                categories: subCategories
            }
        };
    }
    else if (type == 'ELEMENT_CATEGORIES') {
        const subCategories = {};
        const category = state.elements[data.data.id] || {};
        const newData = {
            data: extractSubcategories(data, subCategories, data.data, category.parent_id || 0)
        };

        if (Object.keys(subCategories).length) {
            newData.metadata = {
                categories: subCategories
            };
        }
        return newData;
    }

    return data;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_ELEMENT_CATEGORIES': {
            action.data = transformGetData(state, 'ELEMENT_CATEGORIES', action.data);
            action.diffType = 'ELEMENT_CATEGORIES';
            const newState = reducer(state, action, CATEGORIES);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    [action.data.data.id]: action.data.data
                }
            };
        }

        case 'RECEIVE_CATEGORIES':
        case 'RESPONSE_POST_CATEGORIES': {
            action.data = transformGetData(state, CATEGORIES, action.data);
            return reducer(state, action, CATEGORIES);
        }
        case 'RECEIVE_ELEMENT_CATEGORY_POPULAR_MAKE_IMG': {
            action.data = transformGetData(state, 'ELEMENT_CATEGORY_POPULAR_MAKE_IMG', action.data);
            action.diffType = 'ELEMENT_CATEGORY_POPULAR_MAKE_IMG';
            const newState = popularImgReducer(state, action, 'ELEMENT_CATEGORY_POPULAR_MAKE_IMG');
            const { category_id } = queryStringToParams(action.params);

            const updatedParams = newState.elements[category_id].params.map(param => {
                if (param.key !== 'make') {
                    return param;
                }
                return {
                    ...param,
                    values: param.values.map(val => {
                        const popularImage = action.data?.data.find(img => img.key === val.key);

                        return {
                            ...val,
                            ...(popularImage || {})
                        };
                    })
                };
            });

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    [category_id]: {
                        ...newState.elements[category_id],
                        params: updatedParams
                    }
                }
            };
        }
        case 'ERROR_ELEMENT_CATEGORIES':
        case 'REQUEST_ELEMENT_CATEGORIES': {
            return reducer(state, action, 'ELEMENT_CATEGORIES');
        }

        case 'ERROR_ELEMENT_CATEGORY_POPULAR_MAKE_IMG': {
            return popularImgReducer(state, action, 'ELEMENT_CATEGORY_POPULAR_MAKE_IMG');
        }
        case 'REQUEST_ELEMENT_CATEGORY_POPULAR_MAKE_IMG': {
            return popularImgReducer(state, action, 'ELEMENT_CATEGORY_POPULAR_MAKE_IMG');
        }
        default:
            return reducer(state, action, CATEGORIES);
    }
};
